import { cn } from "@utils/tw"
import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Spacer/Divider",
  category: "content",
  icon: "minus",
  description: "A vertical divider",
  keywords: ["divider", "spacer", "separator"],
  tags: ["#subpage"],
  flags: {
    fullWidth: true,
  },
  blockStyles: [
    {
      name: "space",
      label: "Space",
      isDefault: true,
    },
    {
      name: "divider",
      label: "Divider",
    },
    {
      name: "full-divider",
      label: "Full Divider",
    },
  ],
}

export default defineBlock("content/spacer", (props) => {
  const isDivider = props.blockStyle === "divider" || props.blockStyle === "full-divider"
  let content = null
  if (env.admin) {
    content = (
      <div className="my-6">
        <div
          className={cn(
            "h-4 text-fg-secondary type-body-s flex items-center justify-center relative",
            !isDivider && "border border-dashed border-bg-mid",
          )}
        >
          {isDivider && <div className="absolute top-1/2 h-[1px] bg-bg-mid left-0 right-0" />}
          <span className="bg-bg z-10 px-2 h-2 items-center flex">{isDivider ? "Divider" : "Spacer"}</span>
        </div>
      </div>
    )
  } else {
    content = <div className="my-8 flex items-center">{isDivider && <div className="w-full bg-bg-mid h-[1px]" />}</div>
  }

  if (props.blockStyle === "full-divider") {
    return (
      <div className="w-grid mx-auto my-8">{env.admin ? content : <div className="w-full bg-bg-mid h-[1px]" />}</div>
    )
  } else {
    return <div className="col-subpage-content">{content}</div>
  }
})
